import { useState } from 'react'
import HeartIcon from '@heroicons/react/24/solid/HeartIcon'
import { handlePostRequest, handleDeleteRequest } from '../../utils/api-handler.util'
import { QueryKeys } from '../../utils/queryKeyGenerator'

const FavoriteButton = ({ isFavorite, retailer }) => {
  const [loading, setLoading] = useState(false)

  const toggleFavorite = async (event) => {
    setLoading(true)
    event.preventDefault()

    const url = isFavorite ? `/favorites/retailers?shopId=${retailer.id}` : '/favorites/retailers'
    const data = { shopId: retailer.id }

    if (isFavorite) {
      await handleDeleteRequest(url)
    } else {
      await handlePostRequest(url, data)
    }

    QueryKeys.favoriteRetailers.invalidate(1)
    QueryKeys.retailerShop.invalidate(retailer.shopSlug)

    setLoading(false)
  }

  return (
    <button
      onClick={toggleFavorite}
      disabled={loading}
      title={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
      className="rounded-full text-primary-500 p-2 hover:text-primary-600 transition"
    >
      <HeartIcon
        className={`w-6 h-6 rounded-full ${
          isFavorite ? 'text-foreground-700' : 'text-white  border border-white stroke-primary-700'
        }`}
      />
    </button>
  )
}

export default FavoriteButton
